import axios from 'axios-observable';
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';
import { PageableQuery, TalosPayload, UUID } from '../app/basicModels';
import { PhenomenonPage, Phenomenon, PhenomenonSimple, ClonedCharacteristicsIndicators, CloneCharacteristicsIndicatorsDTO } from './models';
import CONFIG from '../../settings';
import { CommandRequest } from '../../helpers/request/models';
import { ObservationsConfigV2 } from '../observationsConfigV2';

const phenomenonUrl = `${CONFIG.apiUrl}:${CONFIG.demeterPort}/api/v1/phenomenons`;
const phenomenaApiUrl = `${CONFIG.apiUrl}:${CONFIG.demeterPort}/api/v1/phenomena`;

export const getPhenomenons = (_query: PageableQuery, companyId: UUID, showCanonicals: boolean): AxiosObservable<PhenomenonPage> => {
  if (companyId) {
    return axios.get<PhenomenonPage>(
      `${phenomenonUrl}?page=${_query.pageable.page}&size=${_query.pageable.size}&company_id=${companyId}&show_canonicals=${showCanonicals}`
    );
  }
  return axios.get<PhenomenonPage>(
    `${phenomenonUrl}?page=${_query.pageable.page}&size=${_query.pageable.size}&show_canonicals=${showCanonicals}&shallow=true`
  );
};

export const getPhenomenon = (phenomenonId: UUID): AxiosObservable<Phenomenon> => {
  return axios.get<Phenomenon>(`${phenomenonUrl}/by-id/${phenomenonId}`, {
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate'
    }
  });
};

export const getPhenomenonsSimple = (ids: UUID[]): AxiosObservable<PhenomenonSimple> => {
  return axios.post<PhenomenonSimple>(`${phenomenaApiUrl}/ids/simple`, { ids });
};

export const savePhenomenon = (phenomenon: TalosPayload<Phenomenon>, isNew: boolean): AxiosObservable<Phenomenon> => {
  if (isNew) {
    return createPhenomenon(phenomenon);
  }
  return updatePhenomenon(phenomenon);
};

export const createPhenomenon = (phenomenon: TalosPayload<Phenomenon>): AxiosObservable<Phenomenon> => {
  return ObservationsConfigV2.createPhenomenon(phenomenon.payload);
};

export const updatePhenomenon = (phenomenon: TalosPayload<Phenomenon>): AxiosObservable<Phenomenon> => {
  return ObservationsConfigV2.updatePhenomenon(phenomenon.payload);
};

export const deletePhenomenon = (category: TalosPayload<Phenomenon>): AxiosObservable<Phenomenon> => {
  const { id } = category.payload;
  if (!id) throw new Error('Phenomenon id is required');
  return ObservationsConfigV2.deletePhenomenon(id);
};

export const clonePhenomenon = (phenomenonId: UUID, companyId: UUID): AxiosObservable<Phenomenon> => {
  return ObservationsConfigV2.clonePhenomenonToOrg(phenomenonId, companyId);
};

export const clonePhenomenonToWorkspace = (phenomenonId: UUID, workspaceId: UUID): AxiosObservable<Phenomenon> => {
  return ObservationsConfigV2.clonePhenomenonToWorkspace(phenomenonId, workspaceId);
};

export const cloneCharacteristicsIndicators = (
  itemsToClone: CommandRequest<CloneCharacteristicsIndicatorsDTO>
): AxiosObservable<ClonedCharacteristicsIndicators> => {
  return ObservationsConfigV2.clonePhenomenonEntities(itemsToClone.payload);
};
